<input
  class="branding-input"
  [style.background]="color"
  [colorPicker]="color"
  (colorPickerChange)="onColorPickerChange($event)"
  (colorPickerClose)="closed.emit($event)"
  [cpPosition]="position"
  [cpAlphaChannel]="alphaChannel"
  [cpOutputFormat]="outputFormat"
  [cpUseRootViewContainer]="useRootViewContainer"
  [readonly]="true"
  [attr.data-testid]="testId"
/>
<span
  *ngIf="showValue && color"
  class="ml-2 align-middle text-muted font-size-secondary"
  data-testid="brand-color-picker-value"
  >{{ color | uppercase }}</span
>
